
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import DTCls from "@/utils/datetime";
import { countryNoComList, parseTime } from "@/utils";
import { getLedgerAll } from "@/api/request/item";
import Pagination from "@/comp/Pagination/index.vue";
import { xsyzList, xsyzRemove, xsyzShow } from "@/api/request/activity";

//组件
@Component({
  name: "HongBaoYu",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private countryList: any[] = [];
  private propOptions: any[] = [];
  private listLoading: boolean = false;

  //列表请求参数
  private listQuery: any = {
    //临时数据
    expire_time: [], //到期时间
    create_time: [], //创建时间
    blogger_id_str: "", // 博主ID
    creator_id_str: "", // 用户ID

    //页面数据
    page: 1, // 当前页
    page_size: 10, // 页大小

    //时间数据
    create_end_time: "", // 创建结束时间
    expire_end_time: "", // 到期结束时间
    create_start_time: "", // 创建开始时间
    expire_start_time: "", // 到期开始时间

    //请求数据
    blogger_id: 0, // 博主ID
    creator_id: 0, // 用户ID
    m_type: 0, //类型：0-全部，1-全站，2-主页
    s_type: 0, //等级：0-全部，1-普通，2-中级，3-高级
    status: 0, //状态：0-全部，1-显示，2-隐藏
  };

  //时间参数
  get pickerOptions(): any {
    return {
      shortcuts: [
        {
          text: "今日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getTodayStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "昨日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getYesterdayStartTime()), new Date(DTCls.getYesterdayEndTime())]);
          },
        },
        {
          text: "本周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurWeekStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastWeekStartTime()), new Date(DTCls.getLastWeekEdnTime())]);
          },
        },
        {
          text: "本月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurMonthStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastMonthStartTime()), new Date(DTCls.getLastMonthEndTime())]);
          },
        },
        {
          text: "最近一周",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近一个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近三个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "全部",
          onClick(picker: any) {
            picker.$emit("pick", []);
          },
        },
      ],
    };
  }

  //类型列表
  private typeList: any[] = [
    { type: 0, name: "全部类型" },
    { type: 1, name: "全站" },
    { type: 2, name: "主页" },
  ];

  //类型列表
  private levelList: any[] = [
    { level: 0, name: "全部等级" },
    { level: 1, name: "普通" },
    { level: 2, name: "中级" },
    { level: 3, name: "高级" },
  ];

  //状态列表
  private statusList: any[] = [
    { status: 0, name: "全部状态" },
    { status: 1, name: "显示" },
    { status: 2, name: "隐藏" },
  ];

  //创建
  created() {
    //获取列表
    this.getList();
  }

  //获取列表
  private async getList() {
    //显示等待
    this.listLoading = true;

    //时间赋值
    if (this.listQuery.expire_time && this.listQuery.expire_time.length == 2) {
      this.listQuery.expire_end_time = this.listQuery.expire_time[1];
      this.listQuery.expire_start_time = this.listQuery.expire_time[0];
    } else {
      this.listQuery.expire_end_time = "";
      this.listQuery.expire_start_time = "";
    }
    if (this.listQuery.create_time && this.listQuery.create_time.length == 2) {
      this.listQuery.create_end_time = this.listQuery.create_time[1];
      this.listQuery.create_start_time = this.listQuery.create_time[0];
    } else {
      this.listQuery.create_end_time = "";
      this.listQuery.create_start_time = "";
    }
    this.listQuery.blogger_id = Number(this.listQuery.blogger_id_str);
    this.listQuery.creator_id = Number(this.listQuery.creator_id_str);

    //获取数据
    const { data } = await xsyzList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //拆除
  private handleRemove(row: any): void {
    //显示提示
    this.$confirm("确定拆除？", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //请求删除
        const res: any = await xsyzRemove({ id: row.id });

        //删除成功
        if (res.status == 0) {
          //显示提示
          this.$message.success("拆除成功");

          //获取数据
          this.getList();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //显示时间文本
  private showTimeStr(time: number): string {
    //返回结果
    return parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}") as string;
  }

  //修改状态
  private handleStatus(row: any, status: number): void {
    //显示提示
    this.$confirm("确定" + (status == 1 ? "显示" : "隐藏") + "？", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //请求删除
        const res: any = await xsyzShow({ id: row.id, status: status });

        //删除成功
        if (res.status == 0) {
          //显示提示
          this.$message.success((status == 1 ? "显示" : "隐藏") + "成功");

          //获取数据
          this.getList();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
